<template>
  <div style="overflow: hidden">
    <!-- 头部 -->
    <!-- <HeaderModel
      style="position: fixed; top: 0; left: 0; right: 0"
    ></HeaderModel> -->
    <div class="data-collection-scanning">
      <!-- 全屏蒙版倒计时 -->
      <div v-if="isMaskVisible" class="mask-overlay">
        <div class="mask-content">
          <div class="mask-text">请面对摄像头</div>
          <div class="mask-timer">{{ maskCountdown }}</div>
          <div class="mask-text">秒后进入采集</div>
          <!-- <div v-if="loading" class="loading-text">正在启动摄像头...</div> -->
          <div v-if="error" class="error-text">{{ error }}</div>
        </div>
      </div>
      <!-- 返回按钮 -->
      <div class="back-home" @click="goBack">
        <img
          class="back-icon"
          src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/3-11login3.png"
          alt=""
        />
        <span>返回首页</span>
      </div>
      <h1 class="page-title">健康数据采集</h1>
      <p class="page-subtitle">HEALTH DATA COLLECTION</p>
      <div class="scanning-container">
        <!-- 顶部文字 -->
        <div class="top-text">疗愈{{ mode ? "后" : "前" }}数据采集中...</div>

        <!-- 视频区域 -->
        <div class="video-wrapper">
          <!-- 修改为video元素显示摄像头画面 -->
          <video
            ref="videoPreview"
            autoplay
            playsinline
            muted
            class="video-placeholder"
          ></video>
          <img
            v-if="!showRestart"
            class="photo"
            src="https://sz-wonz-1305461842.cos.ap-beijing.myqcloud.com/other/photo.png"
            alt=""
          />

          <!-- 倒计时遮罩 -->
          <div class="timer-overlay">
            <div class="timer-content">
              <span class="timer-text">倒计时：{{ countdown }}秒</span>
            </div>
            <div class="progress-bar">
              <div
                class="progress-fill"
                :style="{ width: progressWidth + '%' }"
              ></div>
            </div>
          </div>
        </div>

        <!-- 按钮 -->
        <button
          v-if="!showRestart"
          class="stop-btn"
          @click="handleStop"
          :disabled="!isRecording"
        >
          <span class="stop-icon">■</span>
          <span>停止采集</span>
        </button>

        <button v-else class="restart-btn" @click="handleRestart">
          <span class="restart-icon">↻</span>
          <span>重新采集</span>
        </button>
      </div>

      <!-- 页脚 -->
      <FooterModel class="po"></FooterModel>
      <!--  -->
    </div>
  </div>
</template>

<script>
import { before_check, after_check } from "@/api/index";
import HeaderModel from "@/components/HeaderModel.vue";
import FooterModel from "@/components/FooterModel.vue";

export default {
  name: "DataCollectionScanning",
  components: {
    FooterModel,
    HeaderModel,
  },
  data() {
    return {
      // 屏幕常亮控制
      wakeLock: null,
      mode: localStorage.getItem("mode"),
      // 蒙版倒计时（5秒）
      maskCountdown: 5,
      // 是否显示蒙版
      isMaskVisible: true,
      // 采集倒计时（30秒）
      countdown: 30, // 30
      // 采集总时长
      totalTime: 30, // 30
      // 蒙版倒计时定时器
      maskTimer: null,
      // 采集倒计时定时器
      timer: null,
      // 平滑进度条百分比
      smoothProgress: 0,

      // 摄像头相关
      stream: null,
      isRecording: false,
      mediaRecorder: null,
      chunks: [],
      loading: false,
      error: "",
      recordingStartTime: null, // 录制开始时间戳
      showRestart: false, // 是否显示重新采集按钮
      uploadLoading: false, // 上传中状态
      recordedBlob: null, // 录制的视频Blob
      recordingDuration: 0, // 录制的时长
    };
  },
  computed: {
    // 计算进度条宽度百分比
    progressWidth() {
      return this.smoothProgress;
    },
  },
  mounted() {
    // 检查浏览器兼容性
    if (!navigator.mediaDevices || !window.MediaRecorder) {
      this.error =
        "您的浏览器不支持媒体录制功能，请使用 Chrome、Firefox 或 Edge 最新版本";
      return;
    }
    // 组件挂载后开始蒙版倒计时并启动摄像头
    this.startMaskTimer();
  },
  methods: {
    goBack() {
      this.$router.replace("/");
    },
    /**
     * 启动摄像头
     */
    async startCamera() {
      this.loading = true;
      this.error = "";

      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: {
            // 宽度：最小640，最大1920，理想1280
            width: { min: 480, ideal: 480, max: 1280 },
            height: { min: 360, ideal: 360, max: 960 },
            frameRate: { ideal: 30 },
            // bitrate: 500000, // 码率500000b（Chrome/Edge支持，Firefox部分支持）
            facingMode: "user",
          },
          audio: false,
        });

        this.stream = stream;

        // 将流绑定到视频元素
        if (this.$refs.videoPreview) {
          this.$refs.videoPreview.srcObject = stream;
        }

        this.loading = false;
        return true;
      } catch (err) {
        this.loading = false;
        console.error("摄像头启动失败:", err);

        if (err.name === "NotAllowedError") {
          this.error = "您拒绝了摄像头访问权限，请允许访问以继续";
        } else if (err.name === "NotFoundError") {
          this.error = "未检测到摄像头设备，请检查连接";
        } else {
          this.error = "摄像头启动失败: " + (err.message || "未知错误");
        }
        return false;
      }
    },
    /**
     * 开始蒙版倒计时（5秒）
     */
    startMaskTimer() {
      // 立即启动摄像头
      this.startCamera();
      this.maskTimer = setInterval(() => {
        if (this.maskCountdown > 0) {
          this.maskCountdown--;
        } else {
          this.hideMaskAndStartCollection();
        }
      }, 1000);
    },

    /**
     * 隐藏蒙版并开始采集
     */
    hideMaskAndStartCollection() {
      if (this.maskTimer) {
        clearInterval(this.maskTimer);
      }
      this.isMaskVisible = false;

      // 开始录制
      this.startRecording();
      // 开始倒计时
      this.startSmoothTimer();
    },

    /**
     * 开始录制视频
     */
    startRecording() {
      if (!this.stream) {
        this.error = "摄像头未启动，无法录制";
        return;
      }

      this.recordingDuration = 0;
      this.isRecording = true;
      this.chunks = [];
      this.recordingStartTime = Date.now();

      try {
        this.mediaRecorder = new MediaRecorder(this.stream, {
          mimeType: "video/webm;codecs=vp9",
        });
      } catch (e) {
        this.mediaRecorder = new MediaRecorder(this.stream);
      }

      this.mediaRecorder.ondataavailable = (e) => {
        if (e.data.size > 0) {
          this.chunks.push(e.data);
        }
      };

      this.mediaRecorder.onstop = () => {
        this.processRecording();
      };

      this.mediaRecorder.start(1000); // 每秒输出一个数据块
      console.log("开始录制...");
    },

    /**
     * 开始平滑的采集倒计时
     */
    startSmoothTimer() {
      const interval = 100; // 每100ms更新一次
      const totalIntervals = this.totalTime * (1000 / interval); // 300次
      let currentInterval = 0;

      this.timer = setInterval(() => {
        currentInterval++;

        // 更新平滑进度条
        this.smoothProgress = (currentInterval / totalIntervals) * 100;

        // 每秒更新倒计时数字
        if (currentInterval % (1000 / interval) === 0) {
          if (this.countdown > 0) {
            this.countdown--;
          } else {
            this.handleComplete();
            return;
          }
        }

        // 达到总时长
        if (currentInterval >= totalIntervals) {
          this.handleComplete();
        }
      }, interval);
    },

    /**
     * 停止采集
     */
    async handleStop() {
      if (!this.isRecording) return;

      // 计算录制时长
      this.recordingDuration = Math.floor(
        (Date.now() - this.recordingStartTime) / 1000
      );

      console.log("录制时长", this.recordingDuration);
      // 检查是否录制时间过短（少于30秒）
      if (this.recordingDuration < 30) {
        this.$pop.open("采集时间过短", "采集时间过短，无法生成报告");
      }

      // 停止录制
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.mediaRecorder.stop();
        this.releaseCamera();
        this.clearAllTimers();
      }

      this.isRecording = false;
      this.showRestart = true;

      // 清除定时器
      this.clearAllTimers();

      console.log("已停止采集");
    },

    // 下载
    downloadVideoBlob(videoBlob, filename = "video.mp4") {
      // 创建临时 URL
      const url = URL.createObjectURL(videoBlob);

      // 创建 a 标签
      const a = document.createElement("a");
      a.href = url;
      a.download = filename;

      // 触发下载
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);

      // 释放内存
      setTimeout(() => {
        URL.revokeObjectURL(url);
      }, 100);
    },
    /**
     * 处理录制完成的视频
     */
    async processRecording() {
      if (this.chunks.length === 0) {
        console.warn("没有录制到视频数据");
        return;
      }

      const blob = new Blob(this.chunks, { type: "video/webm" });
      this.recordedBlob = blob;

      console.log("采集进度%", this.smoothProgress);
      if (this.smoothProgress == 100) {
        // 上传视频
        // this.downloadVideoBlob(blob);
        await this.uploadVideo(blob);
      }
    },

    /**
     * 上传视频到接口
     */
    async uploadVideo(blob) {
      this.uploadLoading = true;
      let isfirst = !this.mode;
      this.$loading.open("数据分析中，请稍候...");
      let that = this;
      let b = blob;
      if (isfirst) {
        let formData = new FormData();
        formData.append("file", blob);
        formData.append("id", JSON.parse(localStorage.getItem("id")));
        formData.append("t", Date.now());
        localStorage.setItem("times", Math.floor(Date.now() / 1000));
        try {
          await before_check(
            formData,
            {
              "Content-Type": "multipart/form-data", // 关键！让浏览器自动加boundary
            },
            {
              t: Date.now(),
              id: JSON.parse(localStorage.getItem("id")),
            }
          ).then((res) => {
            console.log("数据分析成功");
            // this.$toast.success("数据采集完成并上传成功");
            this.$router.replace("/CollectEnd");
          });
        } catch (err) {
          console.error("数据分析失败:", err);
          // this.$toast.error(err);
          this.$pop.open("分析失败", "本次采集分析失败，请重新采集");
        } finally {
          this.uploadLoading = false;
        }
      } else {
        let formData = new FormData();
        formData.append("file", blob);
        formData.append("id", JSON.parse(localStorage.getItem("id")));
        formData.append("mode", this.mode);
        try {
          await after_check(formData, {
            "Content-Type": "multipart/form-data", // 关键！让浏览器自动加boundary
          }).then((res) => {
            console.log("数据分析成功");
            // this.$toast.success("数据采集完成并上传成功");
            this.$router.replace("/ContrastCreate");
          });
        } catch (err) {
          console.error("数据分析失败:", err);
          // this.$toast.error(err);
          if (err.code == 40036) {
            // 检查已完成,请勿重复操作
            this.$router.replace("/ContrastCreate");
          } else {
            this.$pop.open("分析失败", "本次采集分析失败，请重新采集");
          }
        } finally {
          this.uploadLoading = false;
        }
      }
    },

    /**
     * 采集完成（30秒自动结束）
     */
    async handleComplete() {
      if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
        this.mediaRecorder.stop();
      }

      this.isRecording = false;
      this.showRestart = true;
      this.clearAllTimers();
      this.releaseCamera();
      console.log("数据采集完成");
    },

    /**
     * 重新采集
     */
    handleRestart() {
      // 重置所有状态
      this.maskCountdown = 5;
      this.countdown = 30;
      this.smoothProgress = 0;
      this.isMaskVisible = true;
      this.showRestart = false;
      this.error = "";
      this.chunks = [];
      this.recordedBlob = null;
      this.recordingStartTime = null;

      // 清除定时器
      this.clearAllTimers();

      // 释放摄像头
      this.releaseCamera();

      // 重新开始流程
      this.startMaskTimer();
    },

    /**
     * 清除所有定时器
     */
    clearAllTimers() {
      if (this.maskTimer) {
        clearInterval(this.maskTimer);
        this.maskTimer = null;
      }
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },

    /**
     * 释放摄像头资源
     */
    releaseCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
      }
    },
  },
  beforeDestroy() {
    this.releaseCamera();
    this.clearAllTimers();
    if (this.mediaRecorder && this.mediaRecorder.state !== "inactive") {
      this.mediaRecorder.stop();
    }
  },
};
</script>

<style lang="scss" scoped>
@media all and (min-width: 768px) {
  .po {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .data-collection-scanning {
    position: relative;
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    box-sizing: border-box;
    // display: flex;
    // flex-direction: column;
    // justify-content: center;
    // align-items: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .mask-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;

      .mask-content {
        text-align: center;
        color: #ffffff;

        .mask-text {
          font-size: 1.5rem;
          font-weight: 500;
          margin-bottom: 1rem;
        }

        .mask-timer {
          font-size: 8rem;
          font-weight: bold;
          color: #ffffff;
          margin-bottom: 1rem;
          animation: pulse 1s ease-in-out infinite;
        }

        .loading-text {
          font-size: 1rem;
          color: #a0aec0;
          margin-top: 1rem;
        }

        .error-text {
          font-size: 1rem;
          color: #fc8181;
          margin-top: 1rem;
          background: rgba(229, 62, 62, 0.2);
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          margin-top: 2rem;
        }
      }
    }
    /* 返回首页链接（与登录页 .back-home 完全一致） */
    .back-home {
      width: 68.75rem;
      padding-top: 3.75rem;
      margin: auto;
      margin-bottom: 1rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-size: 1.25rem;
      font-weight: 500;
      cursor: pointer;
      user-select: none;

      margin-bottom: 2rem;

      .back-icon {
        width: 1.625rem;
        height: 1.625rem;
        margin-right: 1.1rem;
      }
    }
    .page-title {
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
      margin-bottom: 1rem;
      display: none;
    }

    .page-subtitle {
      font-size: 1rem;
      color: #666;
      text-align: center;
      margin-bottom: 2rem;
      letter-spacing: 0.5px;
      display: none;
    }
    .scanning-container {
      width: 100%;
      max-width: 50rem;
      background: #0f0f1a;
      border-radius: 1.25rem;
      padding: 1.5rem 2rem;
      box-sizing: border-box;
      margin: auto;
      .top-text {
        color: #ffffff;
        font-size: 1.125rem;
        font-weight: 500;
        margin-bottom: 1.5rem;
        text-align: center;
      }

      .video-wrapper {
        position: relative;
        width: 100%;
        border-radius: 1rem;
        overflow: hidden;
        margin-bottom: 1.5rem;
        background: #000;

        .video-placeholder {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
          aspect-ratio: 4/3;
          transform: scaleX(-1); // 镜像显示
        }
        .photo {
          position: absolute;
          left: 0rem;
          right: 0rem;
          top: 5rem;
          margin: auto;
          z-index: 100;
          width: 19rem;
          height: 20rem;
        }

        .timer-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 0, 0, 0.3) 100%
          );
          padding: 1.5rem 1.5rem 1rem;
          backdrop-filter: blur(4px);

          .timer-content {
            margin-bottom: 0.75rem;

            .timer-text {
              color: #ffffff;
              font-size: 1rem;
              font-weight: 500;
            }
          }

          .progress-bar {
            width: 100%;
            height: 0.25rem;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 0.125rem;
            overflow: hidden;

            .progress-fill {
              height: 100%;
              background: #0074fc;
              border-radius: 0.125rem;
              transition: width 0.1s linear;
            }
          }
        }
      }

      .stop-btn,
      .restart-btn {
        width: 100%;
        height: 3.5rem;
        border: none;
        border-radius: 0.75rem;
        color: #ffffff;
        font-size: 1.25rem;
        font-weight: 500;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;

        .stop-icon,
        .restart-icon {
          font-size: 0.875rem;
        }
      }

      .stop-btn {
        background: #e7000b;

        &:hover:not(:disabled) {
          background: #c00009;
        }

        &:disabled {
          background: #999;
          cursor: not-allowed;
          opacity: 0.6;
        }

        &:active:not(:disabled) {
          background: #a00008;
        }
      }

      .restart-btn {
        background: #0074fc;

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }
    }
  }
}

@keyframes pulse {
  0%,
  100% {
    transform: scale(1);
    // opacity: 1;
  }
  50% {
    transform: scale(1.1);
    // opacity: 0.8;
  }
}

@media (max-width: 767px) {
  .po {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
  }
  .data-collection-scanning {
    position: relative;
    min-height: 100vh;
    width: 100%;
    background: linear-gradient(73deg, #e8f2ff 0%, #ffffff 50%, #f4f1ff 100%);
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: top;
    padding-top: 1rem;
    padding-bottom: 12rem;
    align-items: center;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto,
      sans-serif;

    .mask-overlay {
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0, 0, 0, 0.5);
      backdrop-filter: blur(10px);
      -webkit-backdrop-filter: blur(10px);
      display: flex;
      justify-content: center;
      align-items: center;
      z-index: 9999;

      .mask-content {
        text-align: center;
        color: #ffffff;

        .mask-text {
          font-size: 2.25rem;
          font-weight: 500;
          margin-bottom: 1rem;
        }

        .mask-timer {
          font-size: 8.25rem;
          font-weight: bold;
          color: #ffffff;
          margin-bottom: 1rem;
          animation: pulse 1s ease-in-out infinite;
        }

        .loading-text {
          font-size: 1rem;
          color: #a0aec0;
          margin-top: 1rem;
        }

        .error-text {
          font-size: 1rem;
          color: #fc8181;
          margin-top: 1rem;
          background: rgba(229, 62, 62, 0.2);
          padding: 0.75rem 1.5rem;
          border-radius: 0.5rem;
          margin-top: 2rem;
        }
      }
    }
    /* 返回首页链接（与登录页 .back-home 完全一致） */
    .back-home {
      width: 42.375rem;
      margin: 0 auto 4rem;
      padding-top: 4rem;
      display: flex;
      align-items: center;
      color: #4e5361;
      font-weight: 600;
      font-size: 1.75rem;
      cursor: pointer;
      user-select: none;

      .back-icon {
        width: 2.25rem;
        height: 2.25rem;
        margin-right: 1.1rem;
        object-fit: contain;
      }
    }
    .page-title {
      width: 42.375rem;
      margin: 0 auto 0.5rem; /* 与副标题间距较小 */
      font-weight: bold;
      font-size: 3rem;
      color: #101424;
      text-align: center;
    }

    /* 副标题 */
    .page-subtitle {
      width: 42.375rem;
      margin: 0 auto 3rem;
      font-size: 1.2rem;
      color: #9fa1a8;
      text-align: center;
      letter-spacing: 0.1rem;
      font-weight: 400;
    }
    .scanning-container {
      width: 42.375rem;
      background: #0f0f1a;
      border-radius: 1.25rem;
      padding-top: 2.5rem;
      padding-bottom: 2.5rem;
      box-sizing: border-box;
      margin-bottom: 6rem;
      .top-text {
        width: 37.875rem;
        margin: auto;
        font-weight: bold;
        font-size: 2rem;
        color: #ffffff;
        margin-bottom: 2.2rem;
        text-align: left;
      }

      .video-wrapper {
        position: relative;
        width: 37.875rem;
        height: 37.875rem;
        margin: auto;
        border-radius: 1rem;
        overflow: hidden;
        margin-bottom: 1.5rem;
        background: #000;

        .video-placeholder {
          width: 100%;
          height: auto;
          display: block;
          object-fit: cover;
          aspect-ratio: 1/1;
          transform: scaleX(-1); // 镜像显示
        }
        .photo {
          position: absolute;
          left: 0rem;
          right: 0rem;
          top: 3rem;
          margin: auto;
          z-index: 100;
          width: 25rem;
          height: 27rem;
        }

        .timer-overlay {
          position: absolute;
          bottom: 0;
          left: 0;
          right: 0;
          background: linear-gradient(
            to top,
            rgba(0, 0, 0, 0.7) 0%,
            rgba(0, 0, 0, 0.3) 100%
          );
          padding: 1.5rem 1.5rem 1rem;
          backdrop-filter: blur(4px);

          .timer-content {
            margin-bottom: 0.75rem;

            .timer-text {
              color: #ffffff;
              font-size: 1.6rem;
              font-weight: 500;
            }
          }

          .progress-bar {
            width: 100%;
            height: 0.5rem;
            background: rgba(255, 255, 255, 0.2);
            border-radius: 0.25rem;
            overflow: hidden;

            .progress-fill {
              height: 100%;
              background: #0074fc;
              border-radius: 0.125rem;
              transition: width 0.1s linear;
            }
          }
        }
      }

      .stop-btn,
      .restart-btn {
        width: 37.875rem;
        height: 6.5rem;
        margin: auto;
        border: none;
        border-radius: 1.5rem;
        font-weight: 500;
        font-size: 2rem;
        color: #ffffff;
        cursor: pointer;
        transition: all 0.2s;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 0.75rem;

        .stop-icon,
        .restart-icon {
          font-size: 2.5rem;
        }
      }

      .stop-btn {
        background: #e7000b;

        &:hover:not(:disabled) {
          background: #c00009;
        }

        &:disabled {
          background: #999;
          cursor: not-allowed;
          opacity: 0.6;
        }

        &:active:not(:disabled) {
          background: #a00008;
        }
      }

      .restart-btn {
        background: #0074fc;

        &:hover {
          background: #0066e0;
        }

        &:active {
          background: #0058c0;
        }
      }
    }
  }
}
</style>